module.exports = __webpack_public_path__ + "assets/99186f18400abb681f58541b906ded33.png";